import type { FC, ReactNode } from 'react';

import { type OpenPostComposerOptions, PostComposerContext } from './composerContext';

interface PostComposerProviderProps {
  openComposer: (options?: OpenPostComposerOptions) => void;
  children: ReactNode;
}

export const PostComposerProvider: FC<PostComposerProviderProps> = ({ openComposer, children }) => {
  return <PostComposerContext.Provider value={{ openComposer }}>{children}</PostComposerContext.Provider>;
};
